import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { LoadingService, LoaderState } from '@core/services/loading.service';
import { map, delay } from 'rxjs/operators';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html'
})
export class LoadingComponent implements OnInit, OnDestroy {
  private readonly subscription: Subscription;
  public showObservable$: Observable<boolean>;
  public loaderState: LoaderState;

  constructor(
    private readonly loaderService: LoadingService
  ) {
    this.showObservable$ = this.loaderService.loaderStateObservable.pipe(delay(200), map(x => x.displayLoader));
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public showLoader(): boolean {
    return this.loaderState && this.loaderState.displayLoader;
  }
}
